import {theme} from "../../../../utils";

export interface ITermsDialogProps {
    onCloseTermsDialog?: () => void;
    showTermsDialog: boolean;
    contentData?: any;
}

export const termsDialogStyles = {
    closeButtonWrapper: {
        borderRadius: "8px",
        textTransform: "capitalize",
        height: "38px",
        width: '197px'
    },
    contentLabel: {
        ...theme.typography.body1Regular,
        fontSize: "16px",
        mb: "1.875rem",
        pr: "50px",
        color: "#484A4C"
    },
    scrollWrapper: {
        maxHeight: "450px",
        overflow: "auto",
        marginTop: "30px",
        paddingLeft: "50px",
        marginRight: "20px"
    },
    subContent: {
        ...theme.typography.body1Regular,
        marginTop: "1.5rem"
    },
    headerTitleSx: {
        ...theme.typography.opticianBodyRegular,
        fontSize: "24px",
        color: "#252525",
        textAlign: 'left',
    },
    headerSubTitleSx: {
        ...theme.typography.poppinsBodyLight,
        textAlign: 'left',
        lineHeight: "24px",
        mt: "8px",
        fontWeight: 600,
    }
}
